import React, { useEffect, useState } from 'react';
import Question from './Question';

export default function Quiz({ quiz, onResult, result, submissionError }) {
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [durationSec, setDurationSec] = useState(0);

  const getQid = (q) => String(q.id);

  const setAnswer = (qid, value) => {
    setAnswers((prev) => ({ ...prev, [qid]: value }));
  };

  const handleSubmit = () => {
    const total = quiz.questions.length;
    setSubmitted(true);
    if (onResult) onResult({ total, durationSec, answers });
  };

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      setDurationSec(Math.floor((Date.now() - start) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (submissionError) setSubmitted(false);
  }, [submissionError]);

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  return (
    <div className="tw:flex tw:flex-col tw:gap-6 tw:p-4">
      <h2 className="tw:text-xl tw:font-semibold">{quiz.title}</h2>
      {!submitted && (
        <div className="tw:text-right tw:text-sm tw:text-gray-600">Tempo trascorso: {formatTime(durationSec)}</div>
      )}

      {quiz.questions.map((q, idx) => (
        <Question
          key={q.id}
          question={q}
          index={idx}
          selected={answers[getQid(q)]}
          onSelect={(val) => setAnswer(getQid(q), val)}
        />
      ))}

      <button
        className="tw:px-4 tw:py-2 tw:bg-blue-600 tw:text-white tw:rounded"
        onClick={handleSubmit}
        disabled={submitted}
      >
        Invia
      </button>

      {submitted && (
        <div className="tw:p-3 tw:bg-blue-50 tw:text-blue-800 tw:rounded">
          Quiz inviato.
        </div>
      )}
    </div>
  );
}
